var addressIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 15 15\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#7F91A5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.447 8.034v6.427H6.12v-2.843h2.755v2.843h3.674V8.034M0 7.427L7.498 1l7.498 6.427M5.89 6h3.21v2.678h-3.21V6z\"/>\n</svg>";

export { addressIcon as default };
